import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { createEmployee, updateEmployee } from '../api/apiEmployee';
import WrappedTextField from 'common/components/custom/WrappedTextField';
import WrappedFromControlLabel from 'common/components/custom/WrappedFromControlLabel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CreateOrUpdateEmployee extends Component {

    emptyEmployee = {
        isActive: true,
        isInternal: true,
        firstName: '',
        lastName: '',
        email: '',
        businessUnit: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            initialEmployee: JSON.parse(JSON.stringify(this.emptyEmployee)),
            employee: JSON.parse(JSON.stringify(this.emptyEmployee)),
            modelToDelete: JSON.parse(JSON.stringify(this.emptyEmployee))
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.employeeToEdit != null) {
            if (prevState.employee.id !== this.props.employeeToEdit.id) {
                this.setState({ employee: this.props.employeeToEdit, initialEmployee: JSON.parse(JSON.stringify(this.props.employeeToEdit)) });
            }
        }
    }

    closeDialog = () => {
        this.props.onClose();
        this.setState({
            employee: JSON.parse(JSON.stringify(this.emptyEmployee))
        });
    }

    handleChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let { employee } = this.state;

        employee[name] = value;
        this.setState({ employee: employee })
    };


    createOrUpdateEmployee = (e) => {

        e.preventDefault();
        const { employee } = this.state;
        employee.clientId = this.props.selectedClient.id

        if (!this.validateForm()) {
            return;
        }

        let action = this.props.employeeToEdit ? updateEmployee : createEmployee;
        action(employee).then(response => {
            this.props.enqueueSnackbar(
                this.props.t(this.props.employeeToEdit ? 'update_message' : 'create_message', { title: this.props.t('employee') }), { variant: 'success' });
            this.closeDialog()
            !this.props.assetFlag && this.props.getEmployees()
            this.props.assetFlag && this.props.getEmployeesSimple(response.data.data.id)
        }).catch(error => {
            if (error.response.status === 400) {
                this.props.enqueueSnackbar(this.props.t("employee_already_exists"), { variant: 'warning' });
            } else {
                this.props.enqueueSnackbar(this.props.t(this.props.employeeToEdit ? 'error_update_message' : 'error_create_message', { title: this.props.t('employee') }), { variant: 'error' });
            }
        });
    };

    validateForm() {
        let { employee } = this.state;
        let valid = true;
        if (!employee.firstName
            || !employee.lastName
            || !employee.email
        ) {
            valid = false;
        }
        return valid;
    }

    render() {
        let { employee, initialEmployee } = this.state

        return (
            <Dialog onClose={this.closeDialog} open={this.props.isOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom">{this.props.employeeToEdit ? this.props.t("edit_employee") : this.props.t("new_employee")}</DialogTitle>
                <form onSubmit={this.createOrUpdateEmployee} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"first_name"}
                                                name="firstName"
                                                onChange={this.handleChange}
                                                value={employee.firstName}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"last_name"}
                                                name="lastName"
                                                onChange={this.handleChange}
                                                value={employee.lastName}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"email"}
                                            name="email"
                                            onChange={this.handleChange}
                                            value={employee.email}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"business_unit"}
                                            name="businessUnit"
                                            onChange={this.handleChange}
                                            value={employee.businessUnit}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={5} sm={5} md={5} lg={5} xl={5}>
                                        <Grid item container>
                                            <WrappedFromControlLabel
                                                onChange={this.handleChange}
                                                name="isInternal"
                                                checked={employee.isInternal}
                                                label={"internal_employee"}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <Grid item container>
                                            <WrappedFromControlLabel
                                                onChange={this.handleChange}
                                                name="isActive"
                                                checked={employee.isActive}
                                                label={"active"}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.closeDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" disabled={this.props.employeeToEdit ? (JSON.stringify(employee) === JSON.stringify(initialEmployee)) : !this.validateForm()}>
                            {this.props.employeeToEdit ? this.props.t("update") : this.props.t("create")}
                        </Button>
                    </DialogActions>
                </form >
            </Dialog >
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateOrUpdateEmployee)));
